export const sizes = {
	mobileHeaderHeight: 40,
	tabletHeaderHeight: 50,
	deskHeaderHeight: 80,
}
